export enum EstimateType {
    Part,
    Labor,
    HazardousMaterial,
}